export const trackedPEnvKeys = new Set();
export const capitalizeFirstLetter = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};
export const envIsBoolean = val => ['1', 'true'].includes(val);
export const pEnv = new Proxy(process.env, {
  get (envs, key) {
    trackedPEnvKeys.add(key);
    const value = envs[key];
    if (value === undefined) {
      throw new Error(`${key} doesnt exist inside envs.`);
    }
    return value;
  },
});
export const HEADER_X_AW_PERF_UUID = 'x-aw-perf-uuid';
